/** Public URL for the imaging result approval stamp (`REACT_APP_IMAGING_RESULT_STAMP_URL` or `REACT_APP_LAB_RESULT_STAMP_URL`). */
export const IMAGING_RESULT_STAMP_URL =
  process.env.REACT_APP_IMAGING_RESULT_STAMP_URL?.trim() ||
  process.env.REACT_APP_LAB_RESULT_STAMP_URL?.trim() ||
  undefined

/** Optional hospital logo for imaging result / template previews (`REACT_APP_IMAGING_RESULT_LOGO_URL`). */
export const IMAGING_RESULT_LOGO_URL =
  process.env.REACT_APP_IMAGING_RESULT_LOGO_URL?.trim() ||
  process.env.REACT_APP_LAB_RESULT_LOGO_URL?.trim() ||
  undefined

/** Saved on `document.footer.Stamp` when a template result is submitted. */
export const IMAGING_RESULT_FOOTER_STAMP_HTML = IMAGING_RESULT_STAMP_URL
  ? `<img src="${IMAGING_RESULT_STAMP_URL}" alt="Approved stamp" width="200" height="100" />`
  : undefined

export type ImagingResultSignatureValue = {
  previewUrl: string
  signedId: string
}

export function buildImagingResultSignatureHtml(previewUrl: string): string {
  return `<img src="${previewUrl}" alt="Signature" width="200" height="100" />`
}

export function buildImagingResultMediaHtml(previewUrl: string): string {
  return `<img src="${previewUrl}" alt="Media" class="max-h-64 w-auto object-contain" />`
}

export function dataUrlToFile(dataUrl: string, filename = 'signature.png'): File {
  const [header, base64] = dataUrl.split(',')
  const mime = /:(.*?);/.exec(header)?.[1] ?? 'image/png'
  const binary = atob(base64)
  const bytes = new Uint8Array(binary.length)
  for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i)
  return new File([bytes], filename, { type: mime })
}

export function isSignatureImageSrc(value?: string | null): value is string {
  if (!value) return false
  return (
    value.startsWith('http') ||
    value.startsWith('data:') ||
    value.startsWith('blob:') ||
    value.startsWith('/') ||
    value.includes('://')
  )
}

export async function fileFromSignatureSrc(src: string): Promise<File> {
  if (src.startsWith('data:')) return dataUrlToFile(src)
  const res = await fetch(src)
  if (!res.ok) throw new Error('Failed to load signature image')
  const blob = await res.blob()
  return new File([blob], 'signature.png', { type: blob.type || 'image/png' })
}

export function extractImgSrcFromFooterHtml(html?: string): string | undefined {
  if (!html) return undefined
  const match = /src="([^"]+)"/.exec(html)
  return match?.[1]
}
